import { Deserializable } from '../deserializable';

export class SubmissionDecisionDto implements Deserializable {
  public Scoreband: string;
  public DecisionCode: string;
  public ApplicationID: number;
  public DecisionDate?: Date;
  public DecisionSummary: string;
  public DecisionTypeCode: string;
  public UnderwriterFullName: string;

  deserialize(input: any): this {
    Object.assign(this, input);

    return this;
  }
}
